<template>
  <div class="table-wrapper" unselectable="on">
    <table class="main-table">
      <tr>
        <td colspan="3" align="center">
          <div class="input-head-text">Благодарим за пользование нашими услугами</div>
          <div class="input-head-text">Сумма к зачислению {{ sum }} руб</div>
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
        </td>
        <td class="td-nav" width="40%" align="center">
          <img @click="mainClick" src="/imgs/menu_impay_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

import {moneyFormat} from "@/utils/money_format";

export default {
  name: 'PayEndPage',
  data () {
    return {
      loading: false,
      timer: null,
      showMessage: false,
      errorMessage: '',
    }
  },
  computed: {
    amount() {
      const data = this.$store.getters.AMOUNT_PROV
      if (data !== null) {
        return data
      } else {
        return 0.0
      }
    },
    sum() {
      return moneyFormat(this.amount)
    },
  },
  mounted() {
    this.updateTimer()
  },
  methods: {
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.timerExit(), 60000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    timerExit() {
      this.$store.dispatch('AUTH_LOGOUT')
    },
    mainClick() {
      this.stopTimer()
      this.$store.dispatch('GET_CLEAR_PAY_INFO')
      this.$router.go(-4)
    }
  }
}
</script>

<style scoped>

</style>
